import type { Chart } from "../Chart";
import { Theme } from "../theme";
import { computePriceTicks, computeTimeTicks } from "./ticks";

export function drawGrid(ctx: CanvasRenderingContext2D, chart: Chart) {
  const vp = chart.viewport;
  const w = vp.plot.width;
  const h = vp.plot.height;

  ctx.save();
  ctx.lineWidth = 1;

  // horizontal (price) lines
  ctx.strokeStyle = Theme.grid;
  ctx.beginPath();
  for (const t of computePriceTicks(chart)) {
    const y = Math.round(t.y) + 0.5;
    if (y < 0 || y > h) continue;
    ctx.moveTo(0, y);
    ctx.lineTo(w, y);
  }
  ctx.stroke();

  // vertical (time) lines
  const ticks = computeTimeTicks(chart);
  ctx.beginPath();
  ctx.strokeStyle = Theme.grid;
  for (const t of ticks) {
    if (t.major) continue;
    const x = Math.round(t.x) + 0.5;
    if (x < 0 || x > w) continue;
    ctx.moveTo(x, 0);
    ctx.lineTo(x, h);
  }
  ctx.stroke();

  ctx.beginPath();
  ctx.strokeStyle = Theme.gridStrong;
  for (const t of ticks) {
    if (!t.major) continue;
    const x = Math.round(t.x) + 0.5;
    if (x < 0 || x > w) continue;
    ctx.moveTo(x, 0);
    ctx.lineTo(x, h);
  }
  ctx.stroke();

  ctx.restore();
}
